import { __awaiter } from "tslib";
import { TeiLogService } from "@/servicesTs/models/general/teiLog";
import { InterconsultService } from "@/servicesTs/models/interconsult/interconsult";
const moduleTeiLog = {
    namespaced: true,
    state: {
        loading: false,
        teiLog: [],
        interconsult: {},
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getTeiLog(state) {
            return state.teiLog;
        },
        getInterconsult(state) {
            return state.interconsult;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTeiLog(state, data) {
            state.teiLog = data;
        },
        setInterconsult(state, data) {
            state.interconsult = data;
        },
    },
    actions: {
        getTeiLogFindByInterconsult({ commit, state }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const TEI_LOG = yield TeiLogService.getByInterconsultId(id);
                const INTERCONSULT = yield InterconsultService.getById(id);
                commit("setTeiLog", TEI_LOG);
                commit("setInterconsult", (INTERCONSULT === null || INTERCONSULT === void 0 ? void 0 : INTERCONSULT[0]) || {});
                commit("setLoading", false);
            });
        },
    },
};
export default moduleTeiLog;
